let modalLoading = $('#modal-loading')
const useModal = modalLoading.length > 0 ? true : false

/**
 * Check if a form has all required fields filled
 * 
 * @param  {HTMLElement} form The form HTML element
 * @return {bool}
*/
checkForm = form => {
  let required = form.find('input, textarea, select').filter('[required]:visible')
  let isValid = true

  // Check that all required fields are filled
  required.each(function() {
    container = $(this).closest('[class^=col]')
    if ($(this).val() == '' || $(this).val() == null || $(this).val() == undefined) {
      container.addClass('has-error')
      $(this).addClass('is-invalid')
      isValid = false
    } else {
      container.removeClass('has-error')
      $(this).removeClass('is-invalid')
    }
  })
  
  return isValid
}

/**
 * Run the multiple processes to upload files and return list of metas - This should be the only one used in the future!
 * 
 * @param  {element} form The form HTML element
 * @param  {array} selectors The selectors of the files (each one must be unique)
 * @param  {json} data The data to send during the callback
 * @param  {function} callback (Optional) The callback function after successful upload. Default internal store()
 * @return {void}
*/
fromList = (form, list, callback = null) => {
  let total = list.length
  let queue = list.length
  let metas = []
  if (checkForm(form) && total) {
    // Reset the invalid class from fields
    $('select,input,textarea').removeClass('is-invalid')
    // Transition when moving from notiflix
    if (useModal) modalLoading.modal('show')
    // Add uploaded attribute
    list.forEach((file, index) => list[index].uploaded = 0)
    // Upload files
    list.forEach(file => {
      // First ajax
      $.ajax({
        url: form.data('uploadParams'),
        type: 'GET',
      })
      .done((params) => {
        let formData = new FormData()
        Object.keys(params.formInputs).forEach((key) => formData.append(key, params.formInputs[key]))
        formData.append('file', file, params.uuid)
        // Second ajax
        $.ajax({
          url: params.formAttributes.action,
          type: params.formAttributes.method,
          enctype: params.formAttributes.enctype,
          data: formData,
          cache: false,
          contentType: false,
          processData: false,
          xhr: function() {
            var xhr = new window.XMLHttpRequest();
            xhr.upload.addEventListener('progress', function(e) {
                if (e.lengthComputable) {
                  if (useModal) {
                    file.uploaded = (e.loaded/e.total)*100
                    var uploadedPercent = (list.map(f => f.uploaded).reduce((p, n) => p+n))/list.length
                    // Remove the progress bar underterminate
                    modalLoading.find('.progress-bar-indeterminate').removeClass('progress-bar-indeterminate')
                    modalLoading.find(".progress-bar").attr('aria-valuenow', uploadedPercent.toFixed(2)).css('width', `${uploadedPercent.toFixed(2)}%`)
                  }
                }
            }, false)
            return xhr
         },
        })
        .done((res) => {
          queue = queue - 1
          // We add an attribute moved in case controllers or models need to track it
          metas.push({ name: file.name, uuid: params.uuid, size: file.size, moved: false })
        })
        .fail((jqXHR, textStatus) => {
          queue = queue - 1
          console.log(jqXHR)
          // Wrap in try/catch as response could be XML
          try {
            let errors = JSON.parse(jqXHR.responseText).errors
            // Highlight field errors
            for (const key in errors) {
              $(`[name=${fieldName}]`).addClass('is-invalid')
            }
          } catch (err) {
            //
          }
        })
        .always(() => {
          if (useModal && queue === 0) modalLoading.modal('hide')
          if (queue < 1 && callback) callback(metas)
        })
      })
      .fail((jqXHR, textStatus) => {
        console.log(jqXHR)
        if (useModal) modalLoading.modal('hide')
        if (callback) callback(metas)
      })
    })
  } else {
    callback ? callback(false) : false
  }
}

module.exports = {
  fromList
}